const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "แนะนำบริษัท",
    "termsOfService": "ข้อตกลงในการใช้บริการ",
    "privacyPolicy": "นโยบายการจัดการข้อมูลส่วนตัว",
    "guaranteeOfRights": "การรับรองสิทธิ์ของข้อมูลส่วนสำคัญ",
    "customerSupport": "ศูนย์ช่วยเหลือลูกค้า",
    "cookiePolicy": "นโยบายคุกกี้",
    "declarationOfSafety": "ประกาศทางการเกี่ยวกับความปลอดภัยและความไว้วางใจ",
    "youthProtectionPolicy": "นโยบายการคุ้มครองเยาวชน",
    "communityPolicy": "นโยบายชุมชน",
    "probability": "probability",
    "operationPolicy": "นโยบายการดำเนินงาน",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "การให้ความยินยอมในการใช้บริการ NC",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "สัญลักษณ์เพิ่มเติมตามกฎหมายที่เกี่ยวข้องกับเกม",
    "brandInformation": "ข้อมูลบริษัท",
    "copyright": "copyright",
    "channelingInfo": "บริษัท NC จำกัด (มหาชน) เป็นบริษัทกลางการผลิตและจัดจำหน่ายเกมภายใน plaync ไม่ใช่เป็นเจ้าตัวการผลิตและจัดจำหน่ายเกม<br>หน้าที่และความรับผิดชอบทั้งหมดที่เกี่ยวข้องกับการผลิตและจัดจำหน่าย จะอยู่ที่เจ้าตัวเกมแต่ละราย เราจะไม่รับผิดชอบต่อปัญหาใดๆ ที่เกิดขึ้นเกี่ยวกับเรื่องนี้"
  },
  "infoCS": {
    "businessInformation": "ตรวจสอบข้อมูลนักธุรกิจ",
    "infoAddress": "MR. KIM TAEK-JIN และ MR. PARK BYUNG-MOO ประธานบริหารร่วมบริษัท NC จำกัด (มหาชน) เลขทะเบียนนิติบุคคล: 220-81-43000 E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1600-0020 โทรสาร: +82-2-2186-3550",
    "pc": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1600-0020 โทรสาร: +82-2-2186-3550",
    "ncfamilyzone": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1600-0020 โทรสาร: +82-2-2186-3550",
    "other": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1600-0020 โทรสาร: +82-2-2186-3550",
    "none": "",
    "infoEmail": "อีเมล",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(เกม PC)/MobileCS@ncsoft.com/(เกมมือถือ)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "ชื่อเรื่อง",
    "jpGenre": "ประเภท",
    "jpPrice": "ราคา",
    "jpPriceValue": "เล่นฟรี (มีการซื้อในแอป)",
    "jpOs": "การตอบสนอง OS",
    "jpPlatform": "แพลตฟอร์ม",
    "jpDevelopedBy": "ฝ่ายพัฒนา/ฝ่ายบริหาร",
    "jpReleaseDay": "วันที่เปิดให้บริการ",
    "jpReleaseDayValue_LW": "4 พฤศจิกายน 2564"
  },
  "country": {
    "KR": "เกาหลีใต้",
    "TW": "ไต้หวัน",
    "RU": "รัสเซีย",
    "MY": "มาเลเซีย",
    "SA": "ซาอุดิอาระเบีย",
    "SG": "สิงคโปร์",
    "AE": "สหรัฐอาหรับเอมิเรตส์",
    "ID": "อินโดนีเซีย",
    "JP": "ญี่ปุ่น",
    "QA": "กาตาร์",
    "TH": "ไทย",
    "PH": "ฟิลิปปินส์",
    "HK": "ฮ่องกง",
    "UA": "ยูเครน",
    "BY": "เบลารุส",
    "LT": "ลิทัวเนีย",
    "PL": "โปแลนด์",
    "GR": "กรีซ",
    "IL": "อิสราเอล",
    "KW": "คูเวต",
    "AT": "ออสเตรีย",
    "US": "สหรัฐอเมริกา",
    "CA": "แคนาดา",
    "DE": "เยอรมนี",
    "GB": "อังกฤษ",
    "FR": "ฝรั่งเศษ",
    "BR": "บราซิล",
    "IT": "อิตาลี",
    "ES": "สเปน",
    "CL": "ชิลี",
    "NO": "นอร์เวย์",
    "SE": "สวีเดน",
    "IE": "ไอร์แลนด์",
    "PT": "โปรตุเกส",
    "FI": "ฟินแลนด์",
    "DK": "เดนมาร์ก",
    "CH": "สวิตเซอร์แลนด์",
    "AR": "อาร์เจนตินา",
    "PE": "เปรู",
    "MX": "แม็กซิโก",
    "KZ": "คาซัคสถาน",
    "UZ": "อุซเบกิสถาน",
    "AZ": "อาเซอร์ไบจาน",
    "GE": "จอร์เจีย",
    "MD": "มอลโดวา",
    "AM": "อาร์เมเนีย",
    "MO": "มาเก๊า",
    "IN": "อินเดีย",
    "PK": "ปากีสถาน",
    "NL": "เนเธอร์แลนด์",
    "RO": "โรมาเนีย",
    "AU": "ออสเตรเลีย",
    "TR": "ตุรกี",
    "EC": "เอกวาดอร์",
    "CO": "โคลอมเบีย",
    "ZA": "แอฟริกาใต้",
    "EG": "อียิปต์",
    "NC": "Global"
  }
};

export default l10n;
